export default class JwtExpiredError extends Error {
  constructor(message = `JWT is expired`) {
    super(message);
    this.name = 'JwtExpiredError';
  }
}
